import styled, { keyframes } from 'styled-components';
import check from './img/check.svg';

const anim = keyframes`
	0% { transform: translateY(100%); }
	5% { transform: translateY(0); }
	95% { transform: translateY(0); }
	100% { transform: translateY(100%); }
`;

export const Container = styled.div`
	position: fixed;
	right: 0;
	bottom: 0;
	left: 0;
	width: 100%;
	min-height: 80px;
	z-index: 1000;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 10px 24px 10px;
	transform: translateY(100%);
	animation: ${anim} 4.6s 0.3s forwards;
`;

export const Popup = styled.div`
	width: auto;
	max-width: 430px;
	min-height: 56px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 12px;
	padding: 16px 20px 16px 16px;
	background-color: #15153c;
	// background-color: ${({ theme }) => theme.colors.bg1};
`;

export const Icon = styled.div`
	width: 24px;
	height: 24px;
	min-width: 24px;
	min-height: 24px;
	margin-right: 10px;

	background-image: url(${check});
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center center;
`;

export const Text = styled.p`
	color: #fff;
	font-size: 16px;
	font-weight: 500;
	line-height: normal;
	letter-spacing: 0.2px;
`;
